<template>
  <v-container background fluid pa-4 v-scroll="onScrollFunction" class="contain_width">
    <!-- <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page_flex">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="Search_data"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px;"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="Search_data"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px;"
        ></v-text-field>
      </v-flex>
    </v-layout> -->
    <v-flex md12 sm12 xs12>
      <v-layout row wrap pa-4>
        <v-flex md12 sm12 xs12>
          <v-layout row wrap v-if="!showLoading">
            <v-flex lg12 md12 sm12 xs12  v-for="(item, index) in tabledata" :key="index" @click="''">
              <v-card class="coco-box-shadow">
                <v-layout
                  align-center
                  justify-center
                  row
                  fill-height
                  wrap
                  class="coco-list-layout"
                  style=" padding-top: 10px;"
                >
                  <v-flex lg9 md9 sm8 xs9>
                    <v-layout row wrap>
                      <v-flex lg8 md6 sm12 xs12>
                        <span>{{item.code}}&nbsp;&nbsp;{{item.first_name}} {{item.last_name}}</span>
                        <span
                          v-show="isEmpty(item.nick_name) && item.nick_name != 'null'"
                          v-html="' (<span style=color:#166BFF;>'+item.nick_name+'</span>)'"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex lg2 md2 sm2 xs2>
                    <v-layout row wrap class="hidden-xs-only">
                      <v-flex md12 sm12 xs12 text-xs-center>
                        <v-layout row wrap >
                          <v-flex
                            offset-lg5
                            offset-md3
                            lg3
                            md4
                            xs6 
                          >
                            <div v-if="item.buttons == false && (check_permission == true || admin == 'true')">
                              <v-tooltip bottom>
                                <v-btn
                                  slot="activator"
                                  color="warning"
                                  icon
                                  flat
                                  @click="onHandleDialog(true,'create',item)"
                                >
                                  <v-icon>fa-plus</v-icon>
                                </v-btn>
                                <span>{{$t('create')}}</span>
                              </v-tooltip>
                            </div>
                            <div v-if="item.buttons != false && (check_permission == true || admin == 'true')">
                              <v-tooltip bottom>
                              <v-btn
                                slot="activator"
                                color="warning"
                                icon
                                flat
                                @click="onHandleDialog(true,'update',item)"
                              >
                                <v-icon>edit</v-icon>
                              </v-btn>
                              <span>{{$t('edit')}}</span>
                            </v-tooltip>
                            </div>
                          </v-flex>
                          <!-- <v-flex  offset-lg5  offset-md3 lg3 md4 xs6>
                            <div v-if="item.code == items.emp_code">
                            <v-tooltip bottom>
                              <v-btn
                                slot="activator"
                                color="error"
                                icon
                                flat
                                @click="onHandleDialog(true,'update',item)"
                              >
                                <v-icon>edit</v-icon>
                              </v-btn>
                              <span>{{$t('edit')}}</span>
                            </v-tooltip>
                            </div>
                            <div v-else></div>
                          </v-flex> -->
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 class="hidden-sm-and-up">
                    <v-layout row wrap>
                      <v-flex md12 sm12 xs12 text-xs-center>
                        <v-layout row wrap >
                          <v-flex lg6 md6 xs6  text-xs-right>
                            <div v-if="item.buttons == false && (check_permission == true || admin == 'true')">
                            <v-tooltip bottom>
                              <v-btn
                                slot="activator"
                                color="warning"
                                icon
                                flat
                                @click="onHandleDialog(true,'create',item)"
                              >
                                <v-icon>fa-plus</v-icon>
                              </v-btn>
                              <span>{{$t('create')}}</span>
                            </v-tooltip>
                            </div>
                            <div v-if="item.buttons != false && (check_permission == true || admin == 'true')">
                              <v-tooltip bottom>
                             <v-btn
                                slot="activator"
                                color="error"
                                icon
                                flat
                                @click="onHandleDialog(true,'update',item)"
                              >
                                <v-icon>edit</v-icon>
                              </v-btn>
                              <span>{{$t('edit')}}</span>
                            </v-tooltip>
                            </div>
                          </v-flex>
                          <!-- <v-flex lg6 md6 xs6>
                            <div v-if="item.code == items.emp_code">
                            <v-tooltip bottom>
                             <v-btn
                                slot="activator"
                                color="error"
                                icon
                                flat
                                @click="onHandleDialog(true,'update',item)"
                              >
                                <v-icon>edit</v-icon>
                              </v-btn>
                              <span>{{$t('edit')}}</span>
                            </v-tooltip>
                            </div>
                            <div v-else></div>
                          </v-flex> -->
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 class="coco-list-divider" style="margin-top : 10px;">
                    <v-divider />
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- Frm Dialog -->
        <v-flex md12 sm12 xs12>
          <frm-dialog :json_data="dialog_data" v-on:close-dialog="onCloseDialog" />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import EmployeeService from "@/services/EmployeeService";
import Empimage from "../../components/getempimage.vue";
import FrmDialog from "./FormDialog";
//import DeleteDialog from "../../components/master/dialogs/DeleteDialog";
import Utils from "@/utils/";
import { async } from "q";
export default {
  data: () => ({
    Search_data: "",
    Employee_list: [],
    dialog_data: {
      status: false,
      save_type: String,
      data: Object
    },
    tabledata: [],
    checkuser: [],
    check_permission:false,
    admin:false
  }),
  created: function() {
    // this.setShowFilter({
    //   status: 2
    // });
    // this.commitSetToolbar({
    //   patternTool: "0"
    // });
    this.admin = localStorage._is_admin;
    this.checkpermission("IndividualPermissionsList");
    console.log(this.check_permission)
    this.onload = true;
    this.getEmployeeList("Form");
    //let v = this;
    ///this.getPermissionbyEmp();
  },
  //   destroyed: function() {
  //     this.commitToggleAlertDialog({
  //       status: false,
  //       message: Object
  //     });
  //   },
  components: {
    Empimage,
    FrmDialog
  },
  computed: {
    ...mapState("filter", [
      "SelectBranch",
      "SelectDepartment",
      "SelectPosition",
      "SearchData",
      "FromDate",
      "ToDate"
    ]),
    ...mapState("app", ["showLoading"]),
    ...mapState("filter", ["loading", "Employee_List"]),
     ...mapState("permissionmenu", ["permission_List"]),
  },
  methods: {
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    searchProcess() {
      var v = this;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        v.getEmpList("Filter");
      }, 1500);
    },
    onCloseDialog() {
      this.dialog_data.status = false;
      this.getPermissionbyEmp();
    },
    onHandleDialog(status, save_type, data) {
      this.dialog_data = {
        status: status,
        save_type: save_type,
        data: data
      };
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    checkpermission(page){
        let checkEdit = false
        if(this.permission_List.length != 0){
             this.permission_List.forEach(element => {
                 if(page == element.module_name){
                    checkEdit = element.edit;
                 }
             });
        }
        else{
            checkEdit = false;
        }
        this.check_permission = checkEdit
    },
    onScrollFunction(e) {
      let win_scroll_top = e.target.defaultView.pageYOffset;
      let win_height = window.innerHeight;
      let doc_height = document.body.scrollHeight;

      if (win_scroll_top >= (doc_height - win_height) * 0.99) {
        if (!this.processing && this.canLoadMore) {
          this.pageActive += 1;
          this.getProfileDepartmentList();
        }
      }
    },
    // getProfileDepartmentList() {
    //   var detail = [];
    //   this.commitSetShowLoading(true);
    //   SettingService.getProfileDepartmentList(this.pageActive)
    //     .then(res => {
    //       console.log(res.data.content);
    //       this.table_data = res.data.content;
    //     })
    //     .catch(err => {
    //       this.commitToggleAlertDialog({
    //         status: true,
    //         message: err.response.data
    //       });
    //     })
    //     .then(() => {
    //       this.commitSetShowLoading(false);
    //     });
    // },
    async getEmployeeList() {
      await EmployeeService.findEmpPermission()
        .then(res => {
          console.log(res);
          this.Employee_list = [];
          res.data.content.forEach(data => {
            this.Employee_list.push(data);
          });
        })
        .catch(err => {
          console.log(err);
        });

      this.getPermissionbyEmp();
    },
    getPermissionbyEmp() {
      console.log(this.Employee_list);
      console.log("this.checkuser: ", this.checkuser);
        this.tabledata = [];
    for(let i=0;i<this.Employee_list.length;i++){
        //console.log("emp_code: ", this.checkuser[i].code);
        EmployeeService.getPermissionbyEmp(this.Employee_list[i].code)
          .then(res => {
            console.log("getPermissionbyEmp");
            console.log(res);
            console.log("check emp_code: ", this.Employee_list[i].code + "+" + res.data.emp_code);
         
            if (this.Employee_list[i].code == res.data.emp_code) {
              console.log(res);
               
              // res.data.forEach(element => {
              //   this.tabledata.push({
              //     group: element.group,
              //     module_name: element.module_name,
              //     full_control: false,
              //     edit: element.edit,
              //     reads: element.reads
              //   });
              // });
              this.tabledata.push({
                code:this.Employee_list[i].code,
                first_name:this.Employee_list[i].first_name,
                last_name:this.Employee_list[i].last_name,
                buttons:true,
                emp_type:this.Employee_list[i].emp_type,
                is_active:this.Employee_list[i].is_active,
                status:this.Employee_list[i].status,
                user_name:this.Employee_list[i].user_name,
                nick_name:this.Employee_list[i].nick_name,
                });
              console.log("if data : ", this.Employee_list);
              console.log("not data: ", this.tabledata);
            } else if (res.data == undefined) {
              //this.tabledata = [];
              // this.tabledata.push({
              //   code:this.Employee_list[i].code,
              //   first_name:this.Employee_list[i].first_name,
              //   last_name:this.Employee_list[i].last_name,
              //   buttons:false,
              //   emp_type:this.Employee_list[i].emp_type,
              //   is_active:this.Employee_list[i].is_active,
              //   status:this.Employee_list[i].status,
              //   user_name:this.Employee_list[i].user_name,
              //   nick_name:this.Employee_list[i].nick_name,
              //   });
              console.log("not data: ", this.tabledata);
            }
          })
          .catch(err => {
            console.log(err.response.data);
            if (err.response.data) {
              console.log("111111");
              console.log(this.tabledata);
               this.tabledata.push({
                code:this.Employee_list[i].code,
                first_name:this.Employee_list[i].first_name,
                last_name:this.Employee_list[i].last_name,
                buttons:false,
                emp_type:this.Employee_list[i].emp_type,
                is_active:this.Employee_list[i].is_active,
                status:this.Employee_list[i].status,
                user_name:this.Employee_list[i].user_name,
                nick_name:this.Employee_list[i].nick_name,
                });
            } else {
              console.log("222222");
            }

            //this.showSnackBar(err.response.data, "error");
          });

        console.log("55555", this.tabledata);
    }
    },
    getEmpList(Action) {
       EmployeeService.findEmpPermission()
        .then(res => {
          console.log(res);
          this.Employee_list = [];
          res.data.content.forEach(data => {
            this.Employee_list.push(data);
          });
        })
        .catch(err => {
          console.log(err);
        });

      this.getPermissionbyEmp();
    },
  }
};
</script>